export const dividerTheme = {
  bg: 'palette.transparent',
  height: '0px',
  verticalGap: '0px',
};
